module.exports = __webpack_public_path__ + "static/media/207-Kuchen_ID_11w.d89c09ba.mp3";